const React = require('react');
const ButtonBase = require('@material-ui/core/ButtonBase').default;
const AddCircleOutlineIcon
  = require('@material-ui/icons/AddCircleOutline').default;
const Slot = require('./Slot');


module.exports = (props) => {
  return (
    <Slot>
      <AddCircleOutlineIcon className="f30*2 cF"/>
      <div className="ml20">{props.label}</div>
      {
        props.disabled ? null : (
          <ButtonBase
            className="dB*2 abs*2 s"
            component="div"
            onClick={props.onClick}
          />
        )
      }
    </Slot>
  );
};
